import React, { PureComponent } from 'react';
import abcjsObj from 'abcjs';

import Grid from '@material-ui/core/Grid';

import Flute from './Flute';
import Piano from './Piano';
import Xylophone from './Xylophone';
import Guitar from './Guitar';
import { noteFromAbcNote } from '../../lib/noteHelper';

const melodySample = `
%%vocalfont serif 10
X:1
L:1/4
M:4/4
I:linebreak $
K:C
V:1
 C, ^C, D, ^D, | E, F, ^F, G, | ^G, A, ^A, B, | C ^C D ^D | E F ^F G | ^G A ^A B |
w: C3 C#3 D3 D#3 | E3 F3 F#3 G3 | G#3 A3 A#3 B3 | C4 C#4 D4 D#4 | E4 F4 F#4 G4 | G#4 A4 A#4 B4 |
 
  c ^c d ^d | e f ^f g | ^g a ^a b | c' ^c' d' ^d' | e' f' ^f' g' | ^g' a' ^a' b' | 
w: C5 C#5 D5 D#5 | E5 F5 F#5 G5 | G#5 A5 A#5 B5 | C6 C#6 D6 D#6 | E6 F6 F#6 G6 | G#6 A6 A#6 B6 |
`;

class InstrumentsTest extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentNote: null
    };

    this.abcjsCanvasRef = React.createRef();
    this.engraverParams = { add_classes: true, clickListener: this.noteSelected };
    this.parserParams = {};
    this.renderParams = {
      responsive: 'resize'
    };
  }

  render() {
    const { currentNote } = this.state;
    return (
      <Grid container direction={'row'} alignItems={'center'} justify="space-around">
        <Grid item xs={1}>
          <Flute currentNote={currentNote} debug={true} />
        </Grid>
        <Grid item xs container direction="column" alignItems={'stretch'} justify={'space-around'}>
          <Grid item container direction={'row'} alignItems={'center'} justify="space-around">
            <Grid item xs={6}>
              <Piano currentNote={currentNote} debug={true} />
            </Grid>
            <Grid item xs={6}>
              <Xylophone currentNote={currentNote} debug={true} />
            </Grid>
          </Grid>
          <Grid item container direction={'row'} alignItems={'center'} justify="space-around">
            <Guitar currentNote={currentNote} debug={true} />
          </Grid>
          <Grid item>
            <div id={'abcjs-sample'} style={{ width: '100%' }} ref={this.abcjsCanvasRef} />
          </Grid>
        </Grid>
      </Grid>
    );
  }
  componentDidMount() {
    this.renderAbc();
  }

  renderAbc = () => {
    this.tunes = abcjsObj.renderAbc(
      'abcjs-sample',
      melodySample,
      this.parserParams,
      this.engraverParams,
      this.renderParams
    );
  };

  noteSelected = (abcElem, tuneNumber, classes) => {
    console.log(abcElem, tuneNumber, classes);

    const startChar = abcElem.startChar;
    const endChar = abcElem.endChar;
    const abcText = melodySample.substring(startChar, endChar);
    const currentNote = noteFromAbcNote(abcText);
    // TODO: missing default_length argument
    console.log(currentNote.toAbcString(), currentNote.octave);
    this.setState({ currentNote });
  };
}

export default InstrumentsTest;
